module.exports = __webpack_public_path__ + "img/7.826f8b45.jpg";